export enum ErrorCode {
    SSO_PRIVATE_EMAIL = 'LG_0101',
    SSO_UNPROVIDED_EMAIL = 'LG_0100',
    SAME_CARD_FINGERPRINT_TRIAL = 'LG_1001',
}
